import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useAlerts } from '@/feature/alerts/hooks/use-alerts';
import { GASbkEvents } from '@/feature/analytics/sbk/ga-sbk-events';
import { runStoreUpdate } from '@/utils/zustand';

import { useIsBetSlipSubmitting } from './betslip-hooks';
import { useSbkBetSlipStore } from './use-sbk-betslip-store';

export const useClearBetslip = () => {
    const clearBetSlip = useSbkBetSlipStore(state => state.actions.clearBetSlip);
    const { showInfoSheet } = useAlerts();
    const isBetSlipSubmitting = useIsBetSlipSubmitting();
    const { t } = useTranslation('betslip_sbk');

    const handleClearPress = useCallback(() => {
        if (isBetSlipSubmitting) {
            return;
        }

        showInfoSheet({
            title: t('clear_picks'),
            description: "You'll not be able to undo.",
            buttonLabel: t('clear_picks_button'),
            handlePress: () => {
                GASbkEvents.clearBetSlip();
                // We want to batch update the store to prevent crash here
                runStoreUpdate(clearBetSlip);
            },
            errorStyling: true,
            showCancel: true,
        });
    }, [clearBetSlip, isBetSlipSubmitting, showInfoSheet, t]);

    return { handleClearPress };
};
